// removed by extract-text-webpack-plugin
module.exports = {"container":"_2lrZ69tETxj9VOIoN0-SHx","resultsText":"_3Fwg_hMSNAhX1q-ah-3-Wz","text":"_jIUJ0NFh0GUqux97rer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsContainer/ActionText/styles.css
// module id = 396
// module chunks = 0